import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
export const StyledBackdrop = styled.div.withConfig({ displayName: "auir-611444a-StyledBackdrop", componentId: "auir-611444a-16c3xlx" }) `
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;

  background-color: var(${(props) => props.theme.colors.base.grey[100]});
  opacity: ${(props) => (props.open ? 0.7 : 0)};

  transition-timing-function: var(${(props) => props.theme.easing});
  transition-duration: ${(props) => `${props.transitionDuration}ms`};
  transition-property: opacity;
`;
//# sourceMappingURL=Overlay.styles.mjs.mjs.map